<!-- 单品管理 -->
<template>
  <div class="container">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 单品管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <search></search>
    <div class="container">
      <el-row>
        <div class="crumbs">
          <div style="margin-bottom: 20px">
            <d-button btnType="default" btnTxt="批量下架"></d-button>
            <d-button btnType="default" btnTxt="批量上架"></d-button>
            <d-button btnType="default" btnTxt="在线调价" v-on:debounceclick="handleChangePrice"></d-button>
            <d-button btnType="default" btnTxt="批量修改" v-on:debounceclick="goToUrl('/batchEdit')"></d-button>
            <d-button btnType="default" btnTxt="数据导出"></d-button>
            <d-button btnType="default" btnTxt="查看任务"></d-button>
          </div>
        </div>
      </el-row>
      <div class="handle-box">
        <table-list
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :table-option="tableOption"
        @handleButton="handleButton"
        @handleSortChange="handleSortChange"
        @handleSelectionChange="handleSelectionChange">
        <!-- eslint-disable-next-line -->
       <template v-slot:company="slot">
            <img class="sku-img" src="https://t7.baidu.com/it/u=3038817810,32670274&fm=193&f=GIF" alt="">
        </template>
          <!-- eslint-disable-next-line -->
       <template v-slot:stock="slot">
              <div v-if="isShow">
              <span >{{value}}</span>
              <i @click="editAble(scope)" class="el-icon-edit"></i>
              </div>
              <el-input v-else v-model="value" v-focus @blur="handleBler"></el-input>
        </template>
      </table-list>
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="productTagPage.currentPage"
            :page-size="productTagPage.pageSize"
            :total="productTagPage.pageTotal"
            :small="true"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 编辑新增弹框 -->
    <add-unit
      :dialogTitle="dialogTitle"
      :centerDialogVisible="visible"
      @updateVisible="updateVisible"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
      :popupWidth="'500px'"
    >
      <el-form :model="unitForm" :rules="unitRules" ref="unitForm">
        <el-form-item
          label="计量单位名称"
          :label-width="formLabelWidth"
          prop="name"
        >
         <el-col :span="14">
           <el-select
            v-model="unitForm.type"
          >
            <el-option
              v-for="item in isOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
         </el-col>
        </el-form-item>
        <el-form-item
          label="增幅比例(%)"
          :label-width="formLabelWidth"
          prop="region"
        >
        <el-row>
            <el-col :span="10"><el-input width='120px' v-model="unitForm.region" autocomplete="off"></el-input></el-col>
            <el-col :span="4"><span>(1-200)</span></el-col>
        </el-row>

        </el-form-item>
      </el-form>
    </add-unit>

  </div>
</template>

<script>
import addUnit from "@/components/common/epecDialog";
import search from "../../components/product/skuProduct/search";
import tableList from "@/components/common/table-list"
export default {
  data() {
    return {
      tableData:[{id:1,company:'1',status:0},{id:2,company:'2',status:1}],
      tableLabel: [
                  // { label: 'id', param: 'id',  align: 'center', type:'selection',fixed:'left'},
        { label: '单品名称', param: 'email', align: 'center',width:'200' ,fixed:'left'},
        { label: '单品图片', param: 'company', align: 'center' ,slot:'company',fixed:'left'},
        { label: '单品编号', param: 'registTime', align: 'center' ,slot:'time'},
        { label: '品牌', param: 'status', align: 'center', render:  (row) => {
            if (row.status === 0) {
              return '<h3>未审核</h3>'
            } else if (row.status === 1) {
              return '审核通过'
            } else if(row.status ===2) {
              return '审核不通过'
            } else {
              return '禁用'
            }
          }
        },
        { label: '所属分类', param: 'registTime', align: 'center' },
        { label: '上架状态', param: 'registTime', align: 'center' },
        { label: '系列', param: 'registTime', align: 'center' },
        { label: '滚动体列数', param: 'registTime', align: 'center' },
        { label: '内径', param: 'registTime', align: 'center' },
        { label: '外径', param: 'registTime', align: 'center' },
        { label: '宽度', param: 'registTime', align: 'center' },
        { label: '密封防尘形式', param: 'registTime', align: 'center' },
        { label: '保持架材质', param: 'registTime', align: 'center' },
        { label: '库存', param: 'stock', align: 'center' ,fixed:'right',slot:'stock'},
        { label: '起订量', param: 'registTime', align: 'center' ,fixed:'right'},
        { label: '订单是否确认', param: 'registTime', align: 'center' ,fixed:'right'},
        { label: '发货周期(天)', param: 'registTime', align: 'center' ,fixed:'right'},
        { label: '计量单位', param: 'registTime', align: 'center' ,fixed:'right'},
        { label: '市场价(元)', param: 'registTime', align: 'center' ,fixed:'right'},
      ],
      tableOption: {
        label: '操作',
        width: '100',
        fixed:'right',
        permission:'0',
        options: [
          { label: '编辑', type: 'primary', icon: 'el-icon-view', methods: 'preview' },
        ]
      },
      dialogTitle: "新增",
      visible: false,
      unitForm: {
        name: "",
        region: "",
      },
      formLabelWidth: "120px",
      unitRules: {
        name: [
          // { required: true, message: "请输入名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        region: [
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
      },
      product: {},
      licenseList: [],
      productInfoDialog: false,

      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      typeList: [],
      multipleSelection: [],
      productTagAO: {
        productTagList: [],
        typeList: [],
      },
      dialogShow: false,
      productTagList: [{}, {}],
      value:100,
      isShow:true
    };
  },

  components: {
    addUnit,search,tableList
  },
directives: {
  // 注册一个局部的自定义指令 v-focus
  focus: {
    // 指令的定义
    inserted: function (el) {
      // 聚焦元素
      el.querySelector('input').focus()
    }
  }
},
  computed: {},

  created() {},
  methods: {
    handleButton(val){
      console.log(val);
    },
    goToUrl(url){
      this.$router.push({path:url});
    },
    editAble(s){
      console.log(s);
      this.isShow = !this.isShow;

    },
    handleBler(){
      this.isShow = !this.isShow;
    },
    cellHandle(){
      console.log(111);
    },
    updateVisible(val) {
      this.visible = val;
    },
    resetPopupData() {
      //  这里可重置数据
      this.visible = false;
    },
    submitPopupData() {
      //这里向后台 提交数据
    //   this.visible = false;
       this.$refs['unitForm'].validate((valid) => {
          if (valid) {
            // alert('submit!');
            this.visible = false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    handleChangePrice() {
      this.visible = true;
      this.dialogTitle = "在线调价(筛选结果统一调价)";
    },
    handleCurrentChange(){
      this.tableData = [{},{},{}]
    },
    handleSelectionChange(val){
      console.log(val)
    }
  },
};
</script>
<style lang='scss' scoped>
.container {
  margin-bottom: 10px;
  .sku-img{
    width: 70px;
    height: 70px;
  }
}
.handle-box {
  //   margin-bottom: 20px;
}


</style>
